import { Form, DatePicker } from "antd";

const DateField = ({ field }) => (
  <Form.Item
    hidden={field?.hidden}
    key={field.name}
    name={field.name}
    label={field.label}
    rules={field.rules}
    extra={field.extra}
  >
    <DatePicker format="YYYY-MM-DD" disabled={field.disabled} />
  </Form.Item>
);

export default DateField;
